import Vue from 'vue'
import VueRouter from 'vue-router'
import work from './modules/work'
import filed from './modules/filed'
import park from './modules/park'
import yoga from './modules/yoga'
import coupon from './modules/coupon'
Vue.use(VueRouter)

const router = new VueRouter({
  mode:'history',
  routes: [
    ...work,
    ...filed,
    ...park,
    ...yoga,
    ...coupon
  ]
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js